module.exports = __webpack_public_path__ + "img/training-icon.028157ab.svg";